import React from "react";
import styled from "styled-components";

import { InfoIcon } from "src/static/icons";

const DraftProfileBanner: React.FC = () => (
  <Banner role="status">
    <IconFrame>
      <StyledInfoIcon aria-hidden />
    </IconFrame>
    <BannerText>
      Your profile is currently saved as a draft. Publish your profile to make
      it visible in the Hacker Directory and start connecting with other
      hackers!
    </BannerText>
  </Banner>
);

const Banner = styled.div`
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 8px 16px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  background: ${({ theme }) =>
    theme.globalConstants.color.backgroundPrimaryLight};
`;

const IconFrame = styled.span`
  display: inline-flex;
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const StyledInfoIcon = styled(InfoIcon)`
  width: 16px;
  height: 16px;
`;

const BannerText = styled.p`
  min-width: 0;
  margin: 0;
  color: ${({ theme }) => theme.globalConstants.color.textPrimary};
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.body};
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
`;

export default DraftProfileBanner;
